import { z } from 'zod';
import { timeframeSchema } from './timeframe.js';
const pointSchema = z.object({
    time: z.number().int().nonnegative(),
    price: z.number().finite().positive(),
});
export const teachingFibInputSchema = z.object({
    symbol: z.string().min(1).max(32),
    timeframe: timeframeSchema,
    start: pointSchema,
    end: pointSchema,
    note: z.string().max(500).default(''),
});
export const teachingFibPatchSchema = z.object({
    start: pointSchema.optional(),
    end: pointSchema.optional(),
    note: z.string().max(500).optional(),
});
/** Direction follows from the two prices; it is never stored separately. */
export function swingDirection(start, end) {
    return end.price >= start.price ? 'up' : 'down';
}
/**
 * The owner's verdict on a swing the detector drew.
 *
 * Tied to the swing by its identity — timeframe, scale, direction and the
 * start's bar and wick — rather than by an id the detector would have to
 * keep, since it stores nothing. The end is recorded for the reading but is
 * not part of the key: a running end moves, and the verdict is about the
 * swing, not its latest extreme.
 */
export const SWING_VERDICTS = ['approve', 'deny'];
const verdictPointSchema = z.object({
    time: z.number().int().nonnegative(),
    price: z.number().finite().positive(),
    extreme: z.number().finite().positive(),
});
export const swingVerdictInputSchema = z.object({
    symbol: z.string().min(1).max(32),
    timeframe: timeframeSchema,
    scale: z.number().positive(),
    direction: z.enum(['up', 'down']),
    start: verdictPointSchema,
    end: verdictPointSchema,
    running: z.boolean(),
    reversalPct: z.number().positive(),
    verdict: z.enum(SWING_VERDICTS),
    note: z.string().max(500).default(''),
});
export const swingVerdictPatchSchema = z.object({
    verdict: z.enum(SWING_VERDICTS).optional(),
    note: z.string().max(500).optional(),
});
/** The identity a verdict is matched on. */
export function swingVerdictKey(v) {
    return `${v.timeframe}:${v.scale}:${v.direction}:${v.start.time}:${v.start.extreme.toFixed(2)}`;
}
//# sourceMappingURL=teachingFib.js.map